<!--
  +---------------------------------------------------------------------------------------
  | @Copyright: Frippler Copyright (c)
  | @Title:     首页
  +---------------------------------------------------------------------------------------
-->

<template>
  <div class="home-index header-padding">
    <f-page-header />

    <div class="filter-container">
      <div class="filter-box">
        <span class="filter-item">
          <f-radio-btn-group
            v-model="status"
            :groups="radios"
            @change="changeGroup"
          />
        </span>
        <span class="filter-item" v-if="status == 2">
          <el-date-picker
            v-model="query.time"
            type="month"
            :picker-options="pickOptions"
            placeholder="选择月"
            @change="fetchData"
          >
          </el-date-picker>
        </span>
        <span class="filter-item lg">
          <sys-user-selector
            v-model="query.uid"
            @change="fetchData"
            :multiple="false"
            placeholder="全部成员"
          >
          </sys-user-selector>
        </span>
      </div>
    </div>
    <el-row class="table-card" type="flex">
      <el-col :span="16" style="position:relative;">
        <el-card
          v-loading="loading"
          class="table-c"
          shadow="never"
          :body-style="{ height: 'calc(100% - 53px)' }"
        >
          <el-table
            ref="listTable"
            :data="list"
            size="medium"
            height="100%"
            class="padding-small"
          >
            <el-table-column label="结算周期" align="center" min-width="140">
              <template slot-scope="scope">
                {{ scope.row.cycle_time }}
              </template>
            </el-table-column>

            <el-table-column label="姓名" min-width="100" show-overflow-tooltip>
              <template slot-scope="scope">
                <f-user-avatar
                  :user="scope.row"
                  :ellipsisClass="'large '"
                  class="circle"
                  color="#462746"
                >
                </f-user-avatar>
                <f-user-name class="ml-sm" :user="scope.row"></f-user-name>
              </template>
            </el-table-column>

            <el-table-column label="待结算工时" min-width="100" align="right">
              <template slot-scope="scope">
                <span class="number text-bold">{{
                  scope.row.sum_hour_unconfirmed
                }}</span>
                <span>{{ " " + scope.row.standard_unit }}</span>
              </template>
            </el-table-column>

            <el-table-column label="已结算工时" min-width="100" align="right">
              <template slot-scope="scope">
                <span class="number text-bold">{{
                  scope.row.sum_hour_confirmed
                }}</span>
                {{ " " + scope.row.standard_unit }}
              </template>
            </el-table-column>
            <el-table-column label="当月排名" min-width="80" align="center">
              <template slot-scope="scope">
                <span class="number text-bold">{{ scope.row.this_rank || '--'}}</span>
              </template>
            </el-table-column>
            <el-table-column label="较上月排名" min-width="80" align="center">
              <template slot-scope="scope">
                <div
                  v-if="
                    !scope.row.last_rank ||
                    scope.row.last_rank == scope.row.this_rank
                  "
                >
                  --
                </div>
                <div
                  v-else
                  class="
                    flex
                    justify-content-center
                    align-items-center
                    text-bold
                    number
                  "
                >
                  <div
                    v-if="scope.row.last_rank"
                    class="mr-sm"
                    :class="
                      scope.row.last_rank < scope.row.this_rank
                        ? 'nabla text-green'
                        : 'nabla2 text-warning'
                    "
                  ></div>
                  <span
                    :class="
                      scope.row.last_rank < scope.row.this_rank
                        ? ' text-danger'
                        : ' text-green'
                    "
                    >{{
                      Math.abs(scope.row.this_rank - scope.row.last_rank)
                    }}</span
                  >
                </div>
              </template>
            </el-table-column>

            <el-table-column label="操作" align="right" width="160">
              <template slot-scope="scope">
                <el-button type="text" @click="openDetail(scope.row)"
                  >明细</el-button
                >
              </template>
            </el-table-column>

            <template slot="empty">
              <img class="image huger mt-lg" src="@/assets/empty.png" />
              <div class="font-md mb-hg">暂无数据</div>
            </template>
          </el-table>

          <f-table-footer
            :checkbox="false"
            :list="list"
            :total="total"
            :selection="[]"
            :pindex.sync="query.pindex"
            :psize.sync="query.psize"
            @change="fetchData"
            showExport
          >
            <template slot="left">
              <el-button plain size="mini" @click="exportD">导出</el-button>
            </template>
          </f-table-footer>
        </el-card>
      </el-col>
      <el-col :span="8">
        <el-card
          v-loading="loading"
          class="ml table-c"
          shadow="never"
        >
          <div class="detail" v-if="query.time">
            <div class="d-head">
              <span class="title">本月汇总</span
              ><span class="text-muted">{{ sumData.cycle_time }}</span>
            </div>
            <div class="mt">
              <div class="d-data-show">
                <div class="d-item mr">
                  <div class="mt ml">
                    <span class="mr">已结算笔数</span>
                    <!-- <i class="iconfont icon-question text-muted"></i> -->
                  </div>
                  <div class="ml mt-lg">
                    <span class="font-28 number text-bold">{{
                      sumData.cnt_workorder_confirmed
                    }}</span
                    ><span class="ml text-muted">{{ "笔" }}</span>
                  </div>
                </div>
                <div class="d-item ml ellipsis">
                  <div class="mt ml">
                    <span class="mr">已结算工时</span>
                    <!-- <i class="iconfont icon-question text-muted"></i> -->
                  </div>

                  <div class="ml mt-lg ellipsis">
                    <!-- <el-tooltip placement="top">
                      <div slot="content">
                        <span class="font-28">{{ sumData.sum_hour_confirmed }}</span>
                        <span class="ml text-muted">{{ sumData.standard_unit }}</span>
                      </div> -->
                    <span class="font-28 number text-bold">{{
                      sumData.sum_hour_confirmed
                    }}</span>
                    <!-- </el-tooltip> -->

                    <span class="ml text-muted">{{
                      sumData.standard_unit
                    }}</span>
                  </div>
                </div>
              </div>
              <div class="d-data-show">
                <div class="d-item mr">
                  <div class="mt ml">
                    <span class="mr">待结算工时</span>
                    <!-- <i class="iconfont icon-question text-muted"></i> -->
                  </div>
                  <div class="ml mt-lg">
                    <span class="font-28 number text-bold">{{
                      sumData.sum_hour_unconfirmed
                    }}</span>
                    <span class="ml text-muted">{{
                      sumData.standard_unit
                    }}</span>
                  </div>
                </div>
                <div class="d-item ml">
                  <div class="mt ml">
                    <span class="mr">超派工工时</span>
                    <!-- <i class="iconfont icon-question text-muted"></i> -->
                  </div>
                  <div class="ml mt-lg">
                    <span class="font-28 ellipsis number text-bold">{{
                      sumData.sum_hour_beyond
                    }}</span
                    ><span class="ml text-muted">{{
                      sumData.standard_unit
                    }}</span>
                  </div>
                </div>
              </div>
            </div>
            <div class="head-text">排行榜 Top 10</div>
            <div
              id="top-Chart"
              class="topchart"
              :class="topData.length ? '' : 'flex-center column'"
            >
              <img class="image huger mt-lg" src="@/assets/empty.png" />
              <div class="font-md mb-hg">暂无数据</div>
            </div>
          </div>
          <div
            v-else
            class="detail flex column justify-content-center align-items-center"
            style="height: 100%"
          >
            <img src="@/assets/empty.png" class="image huger" />
            <div class="font-md mt-lg text-center">
              请先选择月份，再查看统计数据
            </div>
            <div v-if="topData.length" id="top-Chart" class="topchart"></div>
          </div>
        </el-card>
      </el-col>
    </el-row>
    <workorder-detail
      v-if="detail"
      :show.sync="detail"
      :uid="uid"
      :inittime="query.time"
    ></workorder-detail>
  </div>
</template>

<script>
import {
  userKpiListApi,
  sumApi,
  rankApi,
  exportKDApi,
} from "@/api/kpi/kpiApi.js";
import moment from "moment";
export default {
  name: "KpiUser",

  components: {
    SysUserSelector: () => import("../sys/components/SysUserSelector.vue"),
    WorkorderDetail: () => import("./components/WorkorderDetail.vue"),
  },

  data () {
    return {
      showEditor: false,
      time: 0,
      detail: false,
      uid: undefined,
      sumData: {},
      status: 1,
      query: {
        time: null,
        uid: null,
        pindex: 1,
        psize: 10,
      },
      total: 0,
      radios: [
        { value: 1, title: "本月" },
        { value: 2, title: "历史" },
      ],

      pickOptions: {
        disabledDate: (date) => {
          if (!moment(date).isBefore(moment(new Date()).startOf("month"))) {
            return true;
          } else {
            return false;
          }
        },
      },
      month: [],
      user: {},
      list: [],
      sunData: {},
      loading: false,
      topChart: undefined,
      topData: [],
      topOpt: {
        tooltip: {
          trigger: "axis",
          axisPointer: {
            type: "shadow",
          },
          textStyle: {
            color: "#666",
          },
          valueFormatter: (value) => {
            return value;
          },
          showContent: true,
          borderRadius: 4,
          triggerOn: "mousemove|click",
          extraCssText: "box-shadow: 0 0 3px rgba(0, 0, 0, 0.3);",
          backgroundColor: "#FFFFFF",
          borderRadius: 4,
        },
        grid: {
          left: "13%",
          right: "4%",
          bottom: "10%",
        },
        xAxis: {
          type: "category",
          axisTick: {
            alignWithLabel: true,
          },
          axisLabel: {
            interval: 0,
            rotate: 40,
            align: "center",
            margin: 24,
          },
          data: [],
        },
        yAxis: {
          name: "时长",
          type: "value",
          scale: true,
        },
        series: [],
      },
    };
  },

  created () {
    this.query.time = moment(new Date()).startOf("month").unix() * 1000;

    this.fetchData();
  },

  mounted () { },
  watch: {
    topData () {
      if (!this.topData.length) {
        if (this.topChart) {
          this.topChart.dispose();
        }
      } else {
        this.initChart();
      }
    },
  },
  methods: {
    async fetchData () {
      this.list = [];
      this.topData = [];

      if (this.query.roleid == "") {
        this.query.roleid = null;
      }
      let query = Object.assign({}, this.query);
      query.time = query.time / 1000;
      this.loading = true;
      let resData = await userKpiListApi(query);
      this.loading = false;
      if (!resData.errno) {
        this.list = resData.data.list;
        this.total = resData.data.total;
        let rankData = await rankApi({ time: query.time });
        if (
          !rankData.errno &&
          rankData.data &&
          rankData.data.list.length &&
          rankData.data.list[0].uid != null
        ) {
          this.topData = rankData.data.list;
        } else {
          this.topData = [];
        }
      }

      sumApi({ time: query.time }).then((res) => {
        this.sumData = res.data;
      });
    },

    changeGroup () {
      if (this.status == 1) {
        this.query.time = moment(new Date()).startOf("month").unix() * 1000;
      } else {
        this.query.time =
          moment(new Date()).startOf("month").subtract(1, "months").unix() *
          1000;
      }
      this.fetchData();
    },

    refreshChart () {
      if (this.topChart && this.topData.length) {
        var xdata = {
          data: this.topData
            ? this.topData.map((item) => {
              return item.username;
            })
            : "",
        };
        var series = [
          {
            name: "当月工时",
            type: "bar",
            itemStyle: {
              normal: {
                opacity: 1,
                color: "#409eff",
              },
            },
            barWidth: "30px",
            data: this.topData
              ? this.topData.map(function (item) {
                return item.sum_hour_total;
              })
              : "",
          },
        ];

        this.topOpt.series = series;
        this.topOpt.xAxis = Object.assign({}, this.topOpt.xAxis, xdata);
      }
      this.topChart.setOption(this.topOpt);
    },

    exportD () {
      let time = this.query.time / 1000;
      exportKDApi({ time: time }).then((res) => {
        if (!res.errno) {
          window.open(res.data.url);
          this.$message.success("导出成功！");
        }
      });
    },

    initChart () {
      let dom = document.getElementById("top-Chart");
      this.topChart = this.$echarts.init(dom, "teenager");
      this.refreshChart();
    },

    openDetail (it) {
      this.uid = it.uid;
      this.detail = true;
    },
  },
};
</script>

<style lang="scss" scoped>
.home-index {
  padding-bottom: 0;
  width: 100%;

  .table-card {
    position: relative;
    height: 100%;

    .table-c {
      height: 100%;
      position: relative;
    }

    .detail {
      position: relative;
      min-height: 757px;

      .d-head {
        display: flex;
        justify-content: space-between;

        .title {
          font-size: 18px;
        }
      }

      .d-data-show {
        display: flex;

        .d-item {
          position: relative;
          flex: 1;
          height: 120px;
          margin-top: 20px;
          background-color: #f8f9fc;
        }
      }

      .topchart {
        width: 100%;
        height: 400px;
      }

      .head-text {
        margin-top: 14px;
        font-size: 18px;
      }
    }
  }

  .nabla {
    width: 0px;
    height: 0px;
    border-top: 8px solid #f56c6c;
    border-left: 8px solid transparent;
    border-right: 8px solid transparent;
  }

  .nabla2 {
    width: 0px;
    height: 0px;
    border-bottom: 8px solid #07c160;
    border-left: 8px solid transparent;
    border-right: 8px solid transparent;
  }

  .f-table-footer {
    position: absolute;
    bottom: 0px;
    padding: 16px 0px 16px 20px;
    left: 0px;
    box-shadow: none;
  }
}
</style>
